import { connect } from 'react-redux'
import { doSetLeftSidebarOpenState } from 'actions/app'
import { doShowHotkeysModal } from 'ducks/modals/hotkeys'
import { selectCurrentUserIsAdmin } from 'ducks/currentUser/selectors/base'
import { selectIsLeftSidebarCollapsed } from 'selectors/app'
import { selectIsInInbox } from 'selectors/location'
import { selectMenuNoticeCounts } from 'selectors/menus'
import { selectAccountPreferenceChatEnabled } from 'selectors/app/selectAccountPreferences'

import View from './view'

const select = state => ({
  isLeftSidebarCollapsed: selectIsLeftSidebarCollapsed(state),
  isInInbox: selectIsInInbox(state),
  noticeCounts: selectMenuNoticeCounts(state),
  showWidget: selectCurrentUserIsAdmin(state),
  isChatEnabled: selectAccountPreferenceChatEnabled(state),
})

const perform = {
  doSetLeftSidebarOpenState,
  doShowHotkeysModal,
}

export default connect(select, perform)(View)
export { default as WithGlobalNav } from './WithGlobalNav'
